export const FUNNEL_QA_ACTIONS_ENUM = {
  UPDATE_CURRENT_QUESTION: "UPDATE_CURRENT_QUESTION",
  UPDATE_SELECTED_VALUE: "UPDATE_SELECTED_VALUE",
  UPDATE_QA: "UPDATE_QA",
  UPDATE_OUTCOME: "UPDATE_OUTCOME",
  RESTART_QUESTIONNAIRE: "RESTART_QUESTIONNAIRE"
};

export const QUESTION_POSITION = {
  next: "next",
  last: "last",
  multi: "multi"
};

export const OUTCOME_TYPE = {
  directly: "directly",
  end: "end",
  restart: "restart"
};

export const INSIGHTS_TYPE = {
  ...OUTCOME_TYPE,
  LANDING_PAGE: "landingPage",
  ZIP: "zip",
  QUESTION: "question",
  LEAD_STEP_ONE: "leadStepOne",
  LEAD_CREATED: "leadCreated",
  LEAD: "lead"
};

export const QUESTION_TYPE = {
  ICONS: "ICONS",
  TEXTONLY: "TEXTONLY",
  FREE_TEXT_FIELD: "FREE_TEXT_FIELD",
  SLIDER: "SLIDER"
};

export const FOOTER_FOREGROUND = {
  SHADOWED: "shadowed"
};

export const PHONE_NUMBER_RADIO = {
  STANDARD: "STANDARD",
  LIGHT: "LIGHT",
  VERIFY: "VERIFY"
};

export const THUMBNAIL_TYPE = {
  BACKGROUND: "background", // 1920 x 1080 -> desktop background (for funnel app)
  MOBILE_BACKGROUND: "mobile_background", // 480 x 800 -> mobile background (for funnel app)
  GALLERY_FORM_ASSET: "gallery_form_asset", // 230 x unknown -> gallery form asset
  COMPANY_LOGO: "company_logo", // 580 x unknown -> header logo (for funnel app)
  PARTNER_LOGO: "partner_logo", // 380 x unknown -> footer logo (for funnel app)
  ANSWER_OPTION_ICON: "answer_option_icon", // 214 x unknown -> answer option image
  GALLERY_MODAL_ASSET: "gallery_modal_asset", // 177 x unknown -> gallery modal image
  WEBSITE_SERVICE_ASSET: "website_service_asset" // 400 x 300 -> customer website services images
};

export const MOBILE_BACKGROUND_WIDTH = 480;

export const FUNNEL_DESIGNS = {
  CLASSIC: "CLASSIC",
  MODERN: "MODERN"
};

export const APP_VISIT_TYPES = {
  WEBSITE: "WEBSITE",
  PHONE: "PHONE",
  EMAIL: "EMAIL"
};

export const FORM_IMAGE_PLACEMENT = {
  BEFORE: "BEFORE",
  AFTER: "AFTER"
};

export const LANDING_PAGE_TEMPLATES = {
  FUNNEL_LANDING_PAGE_TEMP_ONE: "FunnelLandingPageTpl1",
  FUNNEL_LANDING_PAGE_TEMP_TWO: "FunnelLandingPageTpl2"
};

export const DIGITAL_SCREENS = {
  OTP: "OTP",
  ESCALATION: "ESCALATION",
  AVAILABILITY: "AVAILABILITY",
  THANKS_DIGITAL: "THANKS-DIGITAL",
  THANKS_MANUAL: "THANKS-MANUAL"
};

export const OTP_LOADING_KEYS = {
  SEND_OTP: "sendOtp",
  VERIFY_OTP: "verifyOtp",
  RESEND_OTP: "resendOtp",
  MANUAL_FALLBACK: "manualFallback",
  SESSION_STATUS: "sessionStatus",
  SUBMIT_AVAILABILITY: "submitAvailability"
};

export const MAX_NUMBER_CORRECTIONS = 2;

// Global TikTok pixel id used by all funnel pages in Phase 1.
export const TIKTOK_PIXEL_DEFAULT_ID = "D66PBGJC77U42FK00EF0";

// TikTok browser event names must match server event names for deduplication.
export const TIKTOK_VIEW_CONTENT_EVENT_NAME = "ViewContent";
export const TIKTOK_SUBMIT_FORM_EVENT_NAME = "SubmitForm";

export const CONVERSION_API_PLATFORM = {
  FACEBOOK: "facebook",
  TIKTOK: "tiktok"
};
